import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from "react";
import { List, ListItem, ListItemText, ListItemAvatar, makeStyles } from "../../..";
import countries from "../../../assets/countries";
import _ from "lodash";

var OfficeList = function OfficeList(_ref) {
  var officeSubscriptions = _ref.officeSubscriptions,
      filterData = _ref.filterData;

  var _useState = useState("ES"),
      _useState2 = _slicedToArray(_useState, 2),
      selectedCountry = _useState2[0],
      setSelectedCountry = _useState2[1];

  var countryList = _.uniq(officeSubscriptions && officeSubscriptions.map(function (office) {
    return countries.find(function (el) {
      return el.value === office.country ? office.country : null;
    });
  })); // console.log("OfficeList countryList", countryList);


  var handleListItemClick = function handleListItemClick(e, country) {
    setSelectedCountry(country);
    filterData(country);
  };

  return /*#__PURE__*/React.createElement(List, {
    dense: true
  }, /*#__PURE__*/React.createElement(ListItem, {
    selected: selectedCountry === "all",
    onClick: function onClick(e) {
      return handleListItemClick(e, "all");
    }
  }, /*#__PURE__*/React.createElement(ListItemText, {
    id: "all",
    primary: "All"
  })), countryList && countryList.map(function (country) {
    return /*#__PURE__*/React.createElement(ListItem, {
      selected: selectedCountry === country.value,
      onClick: function onClick(e) {
        return handleListItemClick(e, country.value);
      }
    }, /*#__PURE__*/React.createElement(ListItemText, {
      id: country.value,
      primary: "".concat(country.label)
    }));
  }));
};

export { OfficeList };